/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Date_And_TimeInputs */

const en_admin_external_booking_edit_date_and_time = /** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date & Time`)
};

const de_admin_external_booking_edit_date_and_time = /** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum & Uhrzeit`)
};

const es_admin_external_booking_edit_date_and_time = /** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha y hora`)
};

const fr_admin_external_booking_edit_date_and_time = /** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date et heure`)
};

const nl_admin_external_booking_edit_date_and_time = /** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum & tijd`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */
const it_admin_external_booking_edit_date_and_time = en_admin_external_booking_edit_date_and_time;

/** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_date_and_time = en_admin_external_booking_edit_date_and_time;

/** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_date_and_time = en_admin_external_booking_edit_date_and_time;

/** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_date_and_time = en_admin_external_booking_edit_date_and_time;

/** @type {(inputs: Admin_External_Booking_Edit_Date_And_TimeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_date_and_time = en_admin_external_booking_edit_date_and_time;

/**
* | output |
* | --- |
* | "Date & Time" |
*
* @param {Admin_External_Booking_Edit_Date_And_TimeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_date_and_time = /** @type {((inputs?: Admin_External_Booking_Edit_Date_And_TimeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Date_And_TimeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "de") return de_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "es") return es_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "it") return it_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_date_and_time(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_date_and_time(inputs)
	return ro_admin_external_booking_edit_date_and_time(inputs)
});
export { admin_external_booking_edit_date_and_time as "admin.external_booking_edit.date_and_time" }